import React, { useEffect, useState } from "react";
import "../Assets/Css/Sidebar.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import dashboardIcon from "../Assets/Images/Sidebar/Dashboard_icon.svg";
import schoolIcon from "../Assets/Images/Sidebar/School_icon.svg";
import bookIcon from "../Assets/Images/Sidebar/book_Icon.svg";
import teacherIcon from "../Assets/Images/Sidebar/Teacher_icon.svg";
import logoutLogo from "../Assets/Images/Sidebar/logout_icon.svg";
import himachalGovIcon from "../Assets/Images/Sidebar/himachal_gov_icon.svg";
import BELOPLogo from "../Assets/Images/Sidebar/BELOP_logo.svg";
import ExportIcon from "../Assets/Images/Sidebar/export_icon.svg";
import TechnicalSupport from "../Assets/Images/Sidebar/technical_support_icon.svg";
import VideoIcon from "../Assets/Images/Sidebar/video_icon.svg";
import $ from "jquery";
import droneImg from "../Assets/Images/Dashboard/drone-img.png";
import robitcsImg from "../Assets/Images/Dashboard/robotics-img.png";
import { EXPORT_REPORT_API, TEACHER_LIST_GET_API } from "./AllApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Sidebar = () => {
  const [isLogin, setIsLogin] = useState(0);
  const [teacherInactiveCount, setTeacherInactiveCount] = useState(
    localStorage.getItem("teacherCount")
  );
  const [data, setData] = useState([]);
  const [toggleStates, setToggleStates] = useState([]);

  const location = useLocation();
  const navigator = useNavigate();

  const getLocalStorageItem = (key) => {
    if (typeof window !== "undefined" && localStorage) {
      return localStorage.getItem(key);
    }
    return null;
  };

  const userRole = getLocalStorageItem("user_role");
  const token = getLocalStorageItem("authToken");
  const referrer = getLocalStorageItem("referrer");
  // const token = localStorage.getItem("authToken");

  // useEffect(() => {
  //   if (location.pathname === "/teacherParticularData") {
  //     $(".teacherNavItem").addClass("active");
  //   }
  // });
  // useEffect(() => {
  //   if (
  //     location.pathname === "/dietParticularData" ||
  //     location.pathname === "/schoolTrainersList"
  //   ) {
  //     $(".dietParticularItem").addClass("active");
  //   }
  // });
  // useEffect(() => {
  //   if (location.pathname === "/notifications") {
  //     $(".dashboardNavItem").addClass("active");
  //   }
  //   if(location.pathname === "/schools" || location.pathname === '/schoolBestTrainers'){
  //     $(".schoolNavItem").addClass("active");
  //   }
  // });

  useEffect(() => {
    if (location.pathname === "/teacherParticularData") {
      // Activate the tab based on referrer
      if (referrer === "/school-dashboard") {
        $(".schoolNavItem").addClass("active");
      } else if (referrer === "/diet") {
        $(".dietParticularItem").addClass("active");
      } else if (referrer === "/teachers") {
        $(".teacherNavItem").addClass("active");
      } else if (referrer === "/dashboard") {
        $(".dashboardNavItem").addClass("active");
      } else if (referrer === "/principal") {
        $(".schoolNavItem").removeClass("active");
        $(".principalNavItem").addClass("active");
      }
    }
    if (location.pathname === "/school-dashboard") {
      if (referrer === "/principal") {
        $(".schoolNavItem").removeClass("active");
        $(".principalNavItem").addClass("active");
      }
      // else if (
      //   referrer === "/school-dashboard" &&
      //   location.pathname === "/schoolBestTrainers"
      // )
      else if (referrer === "/school-dashboard") {
        $(".principalNavItem").removeClass("active");
        $(".schoolNavItem").addClass("active");
      } else {
        $(".schoolNavItem").addClass("active");
      }
    }
    if (location.pathname === "/schoolBestTrainers") {
      if (referrer === "/principal") {
        $(".principalNavItem").addClass("active");
      }
      // else if (
      //   referrer === "/school-dashboard" &&
      //   location.pathname === "/schoolBestTrainers"
      // )
      else if (referrer === "/school-dashboard") {
        $(".schoolNavItem").addClass("active");
      } else {
        $(".schoolNavItem").addClass("active");
      }
    }
    if (
      location.pathname === "/dietParticularData" ||
      location.pathname === "/schoolTrainersList"
    ) {
      $(".dietParticularItem").addClass("active");
    }

    if (
      location.pathname === "/dashboard" ||
      location.pathname === "/notifications" ||
      location.pathname === "/schools"
    ) {
      $(".dashboardNavItem").addClass("active");
    }
  }, [location.pathname, referrer]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(TEACHER_LIST_GET_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Something went wrong");
        }
        // role based fetch
        let data;
        if (userRole === "Admin") {
          const { allTrainers } = await response.json();
          // console.log("Admin trainer data:", allTrainers);
          data = allTrainers;
        } else if (userRole === "Principal") {
          const { schoolTrainers } = await response.json();
          // console.log("Principal trainer data:", schoolTrainers);
          data = schoolTrainers;
        } else if (userRole === "Diet") {
          const { dietTrainers } = await response.json(); // Replace with actual data key
          // console.log("DIET trainer data:", dietTrainers);
          data = dietTrainers;
        } else {
          console.error("Unknown role:", userRole);
          return;
        }

        //setting the data
        setData(data);
        const initialToggleState = data.map(
          (trainer) => trainer.tra_is_active === 1
        );

        setToggleStates(initialToggleState);
      } catch (error) {
        console.error("Error Occured");
      }
    };
    fetchData();
  }, [token, userRole]);

  useEffect(() => {
    // Calculate inactive teacher count
    const inactiveCount = data.reduce(
      (acc, trainer) => acc + (trainer.tra_is_active === 0 ? 1 : 0),
      0
    );
    setTeacherInactiveCount(inactiveCount);
    localStorage.setItem("teacherCount", inactiveCount);
  }, [data]);

  // const handleExportReport = async () => {
  //   try {
  //     const response = await fetch(EXPORT_REPORT_API, {
  //       method: "GET", // Adjust the method and endpoint as per your API
  //       headers: {
  //         Authorization: `bearer ${token}`, // Use the correct token
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     console.log("API Response:", response);

  //     if (!response.ok) {
  //       throw new Error("Failed to download the report");
  //     }

  //     // Assuming the response is a blob or file format
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary anchor element to trigger the download
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "report.pdf"; // Change to the desired file name and extension
  //     document.body.appendChild(a);
  //     a.click();

  //     // Clean up the URL object
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);
  //   } catch (error) {
  //     console.error("Error downloading the report:", error);
  //   }
  // };
  // const handleExportReport = async () => {
  //   const loadingToastId = toast.loading("Exporting report...");

  //   try {
  //     const response = await fetch(EXPORT_REPORT_API, {
  //       method: "GET", // Adjust the method and endpoint as per your API
  //       headers: {
  //         Authorization: `bearer ${token}`, // Use the correct token
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to download the report");
  //     }

  //     // Assuming the response is a blob or file format
  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Create a temporary anchor element to trigger the download
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "report.pdf"; // Change to the desired file name and extension
  //     document.body.appendChild(a);
  //     a.click();

  //     // Clean up the URL object
  //     window.URL.revokeObjectURL(url);
  //     document.body.removeChild(a);

  //     // After download completes
  //     toast.update(loadingToastId, {
  //       render: "Report downloaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   } catch (error) {
  //     console.error("Error downloading the report:", error);

  //     toast.update(loadingToastId, {
  //       render: "Failed to download the report",
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // };
  // const handleExportReport = async () => {
  //   console.log("button clicked")
  //   const loadingToastId = toast.loading("Exporting report...");

  //   try {
  //     console.log("inside call")
  //     console.log("Function invoked from:", window.location.pathname);

  //     const response = await fetch(EXPORT_REPORT_API, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `bearer ${token}`,
  //       },
  //     });
  //     console.log("Function invoked from:", window.location.pathname);

  //     console.log("response: ", response);
  //     if (!response.ok) {
  //       throw new Error("Failed to download the report");
  //     }
  //     const blob = await response.blob(); // Convert response to a blob
  //     console.log("ans: ", response.blob());
  //     const url = window.URL.createObjectURL(blob);

  //     // Create and trigger a temporary download link
  //     const a = document.createElement("a");
  //     a.style.display = "none"; // Hide the anchor
  //     a.href = url;
  //     a.download = "report.pdf"; // Change the name as needed
  //     document.body.appendChild(a);
  //     a.click();

  //     // Cleanup
  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(url); // Revoke the object URL after some time
  //       document.body.removeChild(a); // Remove the anchor from DOM
  //     }, 100);

  //     toast.update(loadingToastId, {
  //       render: "Report downloaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   } catch (error) {
  //     console.error("Error downloading the report:", error);
  //     console.log("error: ",error)

  //     toast.update(loadingToastId, {
  //       render: "Failed to download the report",
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // };

  // const handleExportReport = async () => {
  //   // console.log("button clicked");
  //   const loadingToastId = toast.loading("Exporting report...");

  //   try {
  //     console.log("inside call");
  //     // console.log("Function invoked from:", window.location.pathname);

  //     // Axios API call
  //     const response = await axios.get(EXPORT_REPORT_API, {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Ensure proper authorization
  //       },
  //       responseType: "blob", // Necessary to handle file downloads
  //     });

  //     console.log("response: ", response);

  //     // Create a URL for the blob
  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     // Create a temporary anchor element to trigger the download
  //     const a = document.createElement("a");
  //     a.style.display = "none";
  //     a.href = url;
  //     a.download = "report.pdf"; // Adjust file name as needed
  //     document.body.appendChild(a);
  //     a.click();

  //     // Clean up
  //     setTimeout(() => {
  //       window.URL.revokeObjectURL(url);
  //       document.body.removeChild(a);
  //     }, 100);

  //     toast.update(loadingToastId, {
  //       render: "Report downloaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   } catch (error) {
  //     console.error("Error downloading the report:", error);

  //     toast.update(loadingToastId, {
  //       render: "Failed to download the report",
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // };

  // const handleExportReport = async () => {
  //   const loadingToastId = toast.loading("Exporting report...");
  //   const token = localStorage.getItem("authToken");

  //   try {
  //     console.log("Calling API to export report...");

  //     if (!token) {
  //       throw new Error("Authorization token is missing.");
  //     }

  //     const response = await axios.get(EXPORT_REPORT_API, {
  //       headers: {
  //         Authorization: `bearer ${token}`,
  //       },
  //       responseType: "blob",
  //       timeout: 2 * 60 * 1000, // Set the timeout to 2 minutes
  //     });

  //     console.log("API Response:", response);

  //     if (response && response.data instanceof Blob) {
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = "report.pdf";
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);

  //       toast.update(loadingToastId, {
  //         render: "Report downloaded successfully!",
  //         type: "success",
  //         isLoading: false,
  //         autoClose: 3000,
  //       });
  //     } else {
  //       throw new Error("Received data is not a valid Blob.");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading the report:", error);

  //     let errorMessage = "Failed to download the report";

  //     if (error.code === "ECONNABORTED") {
  //       errorMessage = "Request timed out. Please try again later.";
  //     } else if (error.response) {
  //       errorMessage = "Error in response from the server.";
  //     }

  //     toast.update(loadingToastId, {
  //       render: errorMessage,
  //       type: "error",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // };
  const handleExportReport = async () => {
    const loadingToastId = toast.loading("Exporting report...");
    const token = localStorage.getItem("authToken");

    try {
      // console.log("Calling API to export report...");

      if (!token) {
        throw new Error("Authorization token is missing.");
      }

      const response = await axios.get(EXPORT_REPORT_API, {
        headers: {
          Authorization: `bearer ${token}`,
        },
        responseType: "blob",
        timeout: 2 * 60 * 1000, // Set the timeout to 2 minutes
      });

      console.log("API Response:", response);

      if (response && response.data instanceof Blob) {
        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        let filename = "report.xlsx"; // Default to Excel file

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/);
          if (match && match[1]) {
            filename = match[1]; // Use the filename provided by the server
          }
        }

        // Ensure the filename ends with .xlsx if not explicitly provided
        if (!filename.endsWith(".xlsx")) {
          filename = filename.replace(/\.[^/.]+$/, ""); // Remove existing extension
          filename += ".xlsx"; // Append .xlsx extension
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // Use the determined filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        toast.update(loadingToastId, {
          render: "Report downloaded successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        throw new Error("Received data is not a valid Blob.");
      }
    } catch (error) {
      console.error("Error downloading the report:", error);

      let errorMessage = "Failed to download the report";

      if (error.code === "ECONNABORTED") {
        errorMessage = "Request timed out. Please try again later.";
      } else if (error.response) {
        errorMessage = "Error in response from the server.";
      }

      toast.update(loadingToastId, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  if (isLogin === 1) {
    localStorage.removeItem("authToken");
    navigator("/");
    window.location.reload();
  }
  const handleSectionClick = (section) => {
    window.location.reload();
    localStorage.setItem("selectedSection", section);
  };

  const selectedSection = localStorage.getItem("selectedSection");
  return (
    <>
      <ToastContainer
        position="top-right"
        // autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <nav className="navbar navbar-expand-lg navbar-light">
        {/* <Link className="navbar-brand himachal_sidebar_title" href="#"> */}

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto flex-column vertical-nav">
            <img
              src={himachalGovIcon}
              alt="himachalGovIcon"
              className="himachal_sidebar_title ms-3 mt-3 mb-3"
            />

            <li className="nav-item">
              <NavLink
                className="sidebar_links d-flex mt-2 dashboardNavItem"
                to="/dashboard"
                activeClassName="active-link"
              >
                <img src={dashboardIcon} alt="dashboardIcon" className="me-3" />
                Dashboard
              </NavLink>
            </li>
            {(userRole === "Admin" || userRole === "Diet") && (
              <li className="nav-item ">
                <NavLink
                  className="sidebar_links d-flex mt-2 schoolNavItem"
                  // to="/schools"
                  to="/school-dashboard"
                  activeClassName="active-link"
                >
                  <img src={schoolIcon} alt="schoolIcon" className="me-3" />
                  Schools
                </NavLink>
              </li>
            )}
            {(userRole === "Admin" ||
              userRole === "Principal" ||
              userRole === "Diet") && (
              // || userRole==="undefined"
              <li className="nav-item">
                <NavLink
                  className="sidebar_links d-flex mt-2 teacherNavItem"
                  to="/teachers"
                  activeClassName="active-link"
                >
                  <img src={teacherIcon} alt="teacherIcon" className="me-3" />
                  Teachers{" "}
                  {/* {location.pathname !== "/teacherParticularData" && (
                    <span className="activeTeachersCount ms-2">
                      {teacherInactiveCount}
                    </span>
                  )} */}
                  {/* <span className="activeTeachersCount ms-2">
                    {teacherInactiveCount}
                  </span> */}
                </NavLink>
              </li>
            )}
            {(userRole === "Admin" || userRole === "Diet") && (
              <li className="nav-item ">
                <NavLink
                  className="sidebar_links d-flex mt-2 principalNavItem"
                  to="/principal"
                  activeClassName="active-link"
                >
                  <img src={teacherIcon} alt="principalIcon" className="me-3" />
                  Principal
                </NavLink>
              </li>
            )}
            {userRole === "Admin" && (
              <li className="nav-item ">
                <NavLink
                  className="sidebar_links d-flex mt-2 dietParticularItem"
                  to="/diet"
                  activeClassName="active-link"
                >
                  <img src={schoolIcon} alt="districtIcon" className="me-3" />
                  DIET
                </NavLink>
              </li>
            )}

            <li className="nav-item ">
              <NavLink
                className="sidebar_links d-flex mt-2 "
                to="/curriculum"
                activeClassName="active-link"
              >
                <img src={bookIcon} alt="districtIcon" className="me-3" />
                Syllabus
              </NavLink>
            </li>

            <li className="nav-item ">
              <NavLink
                className="sidebar_links d-flex mt-2 "
                to="/courses"
                activeClassName="active-link"
              >
                <img src={VideoIcon} alt="bookIcon" className="me-3" />
                Videos
              </NavLink>
            </li>

            <li className="nav-item ">
              <buton
                // className="sidebar_links d-flex mt-2 "
                // to="/exportReport"
                // activeClassName="active-link"
                className="d-flex btn export-btn"
                // data-bs-toggle="modal"
                // data-bs-target="#exportmodal"
                onClick={handleExportReport}
              >
                <img src={ExportIcon} alt="ExportIcon" className="me-3" />
                Export Report
              </buton>
            </li>
            <li className="nav-item sidebar_links">
              <div className="d-flex">
                <img
                  src={TechnicalSupport}
                  alt="TechnicalSupport"
                  className="me-1"
                />
                <div className="d-flex flex-column">
                  <p className="pb-0 mb-0" style={{ fontSize: "14px" }}>
                    Technical Support
                  </p>

                  <p className="sidebar_subtext">1800 268 3994</p>
                </div>
              </div>
            </li>

            <span className="logoutSpan my-auto mt-2"></span>
            <li className="nav-item choose_section">
              <p
                className="mt-3 mx-2 mb-3"
                style={{ fontWeight: "700", textAlign: "center" }}
              >
                Switch Section
              </p>
              <p
                className={
                  selectedSection === "Robotics"
                    ? "sidebar_links py-1 my-1 active"
                    : "sidebar_links py-1 my-1"
                }
                onClick={() => handleSectionClick("Robotics")}
                style={{ cursor: "pointer" }}
              >
                <img src={robitcsImg} alt="robitcsImg" width={40} /> Robotics
              </p>
              <p
                className={
                  selectedSection === "Drone"
                    ? "sidebar_links py-1 my-1 active"
                    : "sidebar_links py-1 my-1"
                }
                onClick={() => handleSectionClick("Drone")}
                style={{ cursor: "pointer" }}
              >
                <img src={droneImg} alt="droneImg" width={40} /> Drone
              </p>
            </li>
            <li className="nav-item border-bottom mt-4">
              <Link
                className="sidebar_links d-flex"
                data-bs-toggle="modal"
                data-bs-target="#logoutModal"
                onClick={() => localStorage.removeItem("selectedSection")}
              >
                <img src={logoutLogo} alt="logoutLogo" className="me-3" />
                Log Out
              </Link>
            </li>
            <div className="ms-3">
              <p className="initiativeBy mt-3 mb-1">An Initiative by</p>
              <img src={BELOPLogo} alt="BELOPLogo" width={120} />
            </div>
          </ul>
        </div>
      </nav>
      {/* <!-- Modal --> */}

      <div
        className="modal fade "
        id="logoutModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <p className="logoutTitle mb-0">Log Out</p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <p className="logoutMsg ms-3">Are you sure you want to Logout </p>

            <div className="row mt-3 mb-3">
              <div className="col-lg-6 col-sm-12 col-md-6 text-center">
                <button
                  className="btn  logout_yes_btn w-100 text-center"
                  onClick={() => setIsLogin(1)}
                >
                  Yes
                </button>
              </div>

              <div className="col-lg-6 col-sm-12 col-md-6 text-center">
                <button
                  className="btn logout_no_btn w-100 text-center"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
